import React from "react";
import { MetaPixel } from "./components/MetaPixel";
import { Hero } from "./components/Hero";
import { ProblemSection } from "./components/ProblemSection";
import { BeforeAfter } from "./components/BeforeAfter";
import { PainPoints } from "./components/PainPoints";
import { Distinction } from "./components/Distinction";
import { Volumes } from "./components/Volumes";
import { Bonuses } from "./components/Bonuses";
import { Summary } from "./components/Summary";
import { Testimonials } from "./components/Testimonials";
import { Offer } from "./components/Offer";
import { Guarantee } from "./components/Guarantee";
import { Author } from "./components/Author";
import { FAQ } from "./components/FAQ";
import { FinalCTA } from "./components/FinalCTA";
import { Footer } from "./components/Footer";
import { FloatingCTA } from "./components/FloatingCTA";
import { PurchasePopup } from "./components/PurchasePopup";
export function App() {
  return <div className="min-h-screen w-full overflow-x-hidden bg-cream font-sans text-ink" data-id="element-0" data-mp="23t8g8bfz6dbv">
      <MetaPixel data-id="element-1" data-mp="3ijpcuzwkmx98" />
      <Hero data-id="element-2" data-mp="3ii4r9zs8ioni" />
      <main data-id="element-3" data-mp="3mlawd43m29se">
        <ProblemSection data-id="element-4" data-mp="3ml12v6jcxkhy" />
        <BeforeAfter data-id="element-5" data-mp="3mk85uxa7a9d0" />
        <PainPoints data-id="element-6" data-mp="3mjq3rk0ux0x6" />
        <Distinction data-id="element-7" data-mp="3mj6lu3b7icj5" />
        <Volumes data-id="element-8" data-mp="3rbrakqf99zft" />
        <Bonuses data-id="element-9" data-mp="3rdaq2et386gj" />
        <Summary data-id="element-10" data-mp="3rcsyvwla8ifh" />
        <Testimonials data-id="element-11" data-mp="3recedkz46pg7" />
        <Offer data-id="element-12" data-mp="5yh2n2cyzbp" />
        <Guarantee data-id="element-13" data-mp="6hq1ea16ddl" />
        <Author data-id="element-14" data-mp="4wyzymxdckh" />
        <FAQ data-id="element-15" data-mp="5ggxfcks0yi" />
        <FinalCTA data-id="element-16" data-mp="82kl3wchwbg" />
      </main>
      <Footer data-id="element-17" data-mp="2zld259q0hfbj" />
      <FloatingCTA data-id="element-18" data-mp="2zlv6yuqqp1v2" />
      <PurchasePopup data-id="element-19" data-mp="2zmenq84nlk7i" />
    </div>;
}